import { Calibration } from './calibration.jsx';
import { Gamepads } from './gamepads.jsx';
import { Network } from './network.jsx';
import type { ReactElement } from 'react';

/** `<Watchdog>` component. */
export const Watchdog = (): ReactElement => (
  <>
    <Calibration />
    <Gamepads />
    <Network />
  </>
);
